import * as React from 'react';

import { Paper, Stack, Typography } from '@mui/material';

interface IFormReadOnlySection {
  children: React.ReactNode;
  title: string;
}

function FormReadOnlySection({ children, title }: IFormReadOnlySection) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mx: 1 }}>
      <Stack spacing={2}>
        <Typography variant="h6">{title}</Typography>
        {children}
      </Stack>
    </Paper>
  );
}

export default FormReadOnlySection;
